import { Icon } from "@/components";
import { Common } from "@/components/common";
import {
  DOMAIN_URL,
  SUBSCRIPTION_PRODUCT_TYPE,
  SUPPORT_EMAIL,
} from "@/configuration/globalVariable";
import { useAppSelector } from "@/sharedStore/hooks";
import { getMappingSetKey } from "../utils";
import { useImportOrder } from "../providers/ImportOrderContext";
import { templateFiles } from "../configVariable";

const DownloadTemplate = () => {
  const { state } = useImportOrder();
  const mappingSetKey = getMappingSetKey(
    state.importMethod,
    state.documentType
  );
  const handleDownloadTemplate = () => {
    if (mappingSetKey) {
      const templateUrl = `${DOMAIN_URL}/Content/template/${templateFiles[mappingSetKey]}`;
      const link = document.createElement("a");
      link.href = templateUrl;
      link.download = templateFiles[mappingSetKey];
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const subscriptionProductType = useAppSelector(
    (state) => state.authReducer.user?.subscribedProductType
  );

  const getDownloadTemplateText = () => {
    switch (mappingSetKey) {
      case "importOrders":
      case "importInvoices":
        return "summary only";
      case "importOrdersSales":
      case "importInvoicesSales":
        return "summary and line items";
    }
  };

  return (
    <>
      <div className="mb-6">
        <div className="text-hd5 font-medium mb-2">Download Sample File</div>
        <div className="text-neutral-90 mb-2">
          TOM accepts all import templates, however, if you do not have one you
          can download our template here.
        </div>
        <Common.Button
          variant="link"
          iconLeft={Icon.Download}
          className="px-0"
          onClick={handleDownloadTemplate}
        >
          Download template file for {getDownloadTemplateText()}
        </Common.Button>
      </div>

      <div>
        <div className="text-hd5 font-medium mb-2">Need further support?</div>
        <div className="text-neutral-90 mb-2">
          Importing your{" "}
          {subscriptionProductType === SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY
            ? "invoices"
            : "orders/invoices"}{" "}
          with a CSV file is easy. But if you need a little help, please email
          our support team at{" "}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="text-blue hover:underline"
          >
            {SUPPORT_EMAIL}
          </a>
          .
        </div>
      </div>
    </>
  );
};

export default DownloadTemplate;
